import {Inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {PageLogin} from "../../models/page-login";
import {AuthConstants} from "../../constants/auth/auth-constants";
import {environment} from "../../../environments/environment";
import { PopupType } from "src/app/components/tools/page-login-popups/models/popupType.model";
import { EnvironmentService } from "../environment.service";


@Injectable({
  providedIn: 'root'
})

export class pageLoginService{
  constructor(private readonly http: HttpClient, private readonly environmentService: EnvironmentService) { }

  getPageLogin(id: number): Observable<any> {
    console.log("this.environmentService.get().serverUrl", this.environmentService.get().serverUrl);
    return this.http.get<PageLogin>(this.environmentService.get().serverUrl+AuthConstants.PAGE_LOGIN+this.environmentService.get().companySiteIdentifier);
  }

  /**
 * Récupérer les popups de page login
 * @param popupType 
 * @returns 
 */
  getPageLoginPopups(popupType: PopupType): Observable<any> {
    const req = {
      "companySiteId": this.environmentService.get().companySiteIdentifier,
      "popupType": popupType
    }
    return this.http.post(this.environmentService.get().serverUrl + AuthConstants.PAGE_LOGIN + "popups", req);
  }
}

